import React, { useState, useEffect } from 'react';
import { api } from '@/utils/api';
import { Calendar, User } from 'lucide-react';

export default function BlogPage() {
  const [blogs, setBlogs] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');

  useEffect(() => {
    fetchBlogs();
  }, [selectedCategory]);

  const fetchBlogs = async () => {
    try {
      const params = selectedCategory !== 'all' ? { category: selectedCategory } : {};
      const response = await api.getBlogs(params);
      setBlogs(response.data);
    } catch (error) {
      console.error('Failed to fetch blogs:', error);
    }
  };

  const categories = ['all', 'Event Planning', 'Destination Guides', 'Industry Trends', 'Case Studies'];

  return (
    <div className="min-h-screen pt-24 pb-20 px-6 bg-slate-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <h1 className="luxury-text text-5xl font-medium tracking-tight text-midnight-navy mb-4" data-testid="blog-page-title">
            Corporate Event Industry Insights
          </h1>
          <p className="text-lg text-slate-800">
            Expert tips, industry trends, and success stories from the world of corporate events
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex gap-4 mb-12 overflow-x-auto pb-2">
          {categories.map(category => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-2 rounded-sm font-medium whitespace-nowrap transition-all ${
                selectedCategory === category
                  ? 'bg-midnight-navy text-white'
                  : 'bg-white text-slate-700 hover:bg-slate-100 border border-slate-200'
              }`}
              data-testid={`category-${category}`}
            >
              {category === 'all' ? 'All Articles' : category}
            </button>
          ))}
        </div>

        {/* Blog Grid */}
        {blogs.length === 0 ? (
          <div className="text-center py-20 bg-white rounded-sm border border-slate-200">
            <p className="text-slate-800">No articles found in this category.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {blogs.map(blog => (
              <article
                key={blog.id}
                className="bg-white rounded-sm overflow-hidden border border-slate-200 hover:shadow-[0_12px_24px_rgba(0,0,0,0.06)] transition-all"
                data-testid={`blog-card-${blog.id}`}
              >
                <img
                  src={blog.image_url}
                  alt={blog.title}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6 space-y-3">
                  <span className="text-xs font-semibold text-champagne-gold uppercase">
                    {blog.category}
                  </span>
                  <h3 className="luxury-text text-xl font-medium line-clamp-2">
                    {blog.title}
                  </h3>
                  <p className="text-sm text-slate-800 line-clamp-3">
                    {blog.content.substring(0, 150)}...
                  </p>
                  <div className="flex items-center gap-4 text-xs text-slate-800 pt-4 border-t border-slate-100">
                    <div className="flex items-center gap-1">
                      <User className="w-3 h-3" />
                      <span>{blog.author}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Calendar className="w-3 h-3" />
                      <span>{new Date(blog.created_at).toLocaleDateString()}</span>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
